import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from 'next/image';
import NextLink from 'next/link';
import { Box, Button } from '@chakra-ui/react';
export const TextCard = ({ theme = 'dark', textAlign = 'center', image, description, title, button, root, }) => {
    const alignItems = alignItemsValue[textAlign];
    return (_jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", layerStyle: theme, alignItems: alignItems, textAlign: textAlign, px: 6, py: 12, ...root, children: [image?.src && (_jsx(Box, { mb: 6, children: _jsx(Image, { src: image.src, alt: image?.alt ?? '', width: 50, height: 50 }) })), title?.children && (_jsx(Box, { textStyle: ['Mobile/XS', null, 'Desktop/S'], my: 2, ...title })), description?.children && (_jsx(Box, { textStyle: "Desktop/Body-Default", my: 2, ...description })), button?.children && !button?.href && (_jsx(Button, { layerStyle: theme, variant: "ghost", flexGrow: 0, mt: 6, ...button })), button?.children && button?.href && (_jsx(NextLink, { href: button.href ?? '', passHref: true, children: _jsx(Button, { as: "a", layerStyle: theme, variant: "ghost", flexGrow: 0, mt: 6, px: textAlign !== 'center' ? 0 : undefined, _hover: {
                        bg: 'none',
                    }, _active: {
                        bg: 'none',
                    }, ...button }) }))] }));
};
const alignItemsValue = {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end',
};
